import * as z from 'zod'

export const AssetSchema = z.lazy(() =>
  z.object({
    fields: z.object({
      description: z.string().optional(),

      file: z.object({
        url: z.string(),
        details: z
          .object({
            image: z
              .object({
                width: z.number(),
                height: z.number(),
              })
              .optional(),
          })
          .optional(),
      }),
    }),
  }),
)

export type Asset = z.infer<typeof AssetSchema>
